export type Skill = {
  Lessons: SkillPart[];
  Polls: SkillPart[];
  Practices: SkillPart[];
  children: SkillChildren[];
  id: string;
  name: string;
  type: string;
};

export enum SkillPartType {
  LESSON = 'LESSON',
  PRACTICE = 'PRACTICE',
  POLL = 'POLL',
}

export type CourseLocation = {
  courseId: string;
  skillId: string;
  entityId: string;
  entityType: SkillPartType;
};

export type SkillPart = {
  id: string;
  type: SkillPartType;
  name: string;
  hasPassed: boolean;
  isAccessible: boolean;
};

export type SkillChildren = {
  id: string;
  type: SkillPartType;
};
